import Vue from 'vue'
import Vuex from 'vuex'
import axios from '../axios-auth.js'
import router from '../router/index.js'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    nombre: null,
    usuario: null,
    clave: null
  },

  mutations: {
    guardarNombreUsuClave(state, datosUsuario)
    {
      state.nombre = datosUsuario.nombre
      state.usuario = datosUsuario.usuario
      state.clave = datosUsuario.clave
    }
  
  },
  
  actions: {
    guardarNombreUsuClave({commit}, datosUsuario)
    {
      commit('guardarNombreUsuClave', datosUsuario)
    }
  },

  modules: {
  },
  plugins: [createPersistedState()]
})
